import { gql } from '@apollo/client'

export const CUSTOMER_CASES_QUERY = gql`
  query customers($page: Int, $limit: Int, $filter: CustomerFilter, $sortBy: CustomerSort) {
    customers(page: $page, limit: $limit, filter: $filter, sortBy: $sortBy) {
      collection {
        id
        salutation
        firstname
        lastname

        cases {
          id
          claimNumber
          rsvLegalArea {
            title
          }
          project {
            title
          }
          caseState
          processings {
            actualProcessingType {
              title
            }
            assignedProcessingType {
              title
            }
          }
          assignedToM2At
          comments
          policyholder {
            policyNumber
            lastname
            firstname
            name
          }
        }
      }
    }
  }
`
